import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CLOSED_LA_COOKIE } from 'constants/cookies';
import { HYDRA_LAS, HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';

import { inIframe } from 'helpers/CheckoutUtils';
import { getAssignmentGroup, isAssigned, triggerAssignment } from 'actions/ab';
import { onCloseLoginAssistantClick, onLoginFromLoginAssistantClick, onShowLoginAssistant } from 'store/ducks/loginAssistant/actions';
import llamaImage from 'images/llama-circle.svg';
import css from 'styles/components/loginAssistant.scss';
import { close as modalClose } from 'styles/components/common/modal.scss';

export class LoginAssistant extends Component {
  state = {
    isShown: true
  };

  componentDidMount() {
    const { marketplace: { showLoginAssistant } } = this.context;
    if (showLoginAssistant) {
      this.props.triggerAssignment(HYDRA_LAS);
      this.props.triggerAssignment(HYDRA_PERSONALIZATION_MARKER);
    }
  }

  componentDidUpdate({ isInLoginAssistantTest: prevIsInLoginAssistantTest }) {
    const { hideLADueToCustomerClosedIt, isInLoginAssistantTest, isRecognizedCustomer } = this.props;
    const { isShown } = this.state;
    const isHidden = hideLADueToCustomerClosedIt || isRecognizedCustomer || !isShown;

    if (!isHidden && isInLoginAssistantTest && prevIsInLoginAssistantTest !== isInLoginAssistantTest) {
      this.props.onShowLoginAssistant();
    }
  }

  onHideLoginAssistantFromLinkClick = e => {
    e.preventDefault();
    this.setState({ isShown: false });
    this.props.onCloseLoginAssistantClick();
  }

  onGoToLoginClick = e => {
    e.preventDefault();
    const { locationBeforeTransitions: { pathname }, onLoginFromLoginAssistantClick } = this.props;
    onLoginFromLoginAssistantClick(pathname);
  }

  render() {
    const { marketplace: { showLoginAssistant }, testId } = this.context;

    if (!showLoginAssistant || inIframe()) {
      return null;
    }

    const { hideLADueToCustomerClosedIt, isInLoginAssistantTest, isRecognizedCustomer, hydraPersonalizationMarker } = this.props;
    const { isShown } = this.state;

    if (hideLADueToCustomerClosedIt || !isInLoginAssistantTest || isRecognizedCustomer) {
      return null;
    }

    let personalizedImage = null;
    if (hydraPersonalizationMarker) {
      const iconClassName = isRecognizedCustomer ? css.pRecMrkSmall : css.pNonRecMrkSmall;
      personalizedImage = <span className={iconClassName} aria-label="Personalization icon" />;
    }

    return (
      <aside
        data-test-id={testId('loginAssistant')}
        className={cn(css.wrapper, { [css.fadeOut]: !isShown })}
        role="dialog">
        <div className={css.modalHeader}>
          <p className={css.header}>
            {personalizedImage}
            Sign in for personalized recommendations!
          </p>
          <button
            onClick={this.onHideLoginAssistantFromLinkClick}
            className={modalClose}
            data-test-id={testId('closeModal')}
            aria-label="Close" />
        </div>

        <div className={css.lasBody}>
          <div className={css.speechBubble}>
            Returning customers enjoy a tailored shopping experience:
            <ul>
              <li>Size recommendations on product pages</li>
              <li>"Best for You" search results</li>
              <li>Zappos Rewards members get points for purchases and logging in</li>
            </ul>
          </div>
          <img src={llamaImage} alt="" />
        </div>

        <div className={css.footer}>
          <form action={'tbd'} method="post">
            <button
              type="button"
              disabled={false}
              onClick={this.onHideLoginAssistantFromLinkClick}
              className={css.cancelBtn}
              data-test-id={testId('dismissBtn')}>Dismiss</button>

            <button
              type="submit"
              className={css.loginBtn}
              onClick={this.onGoToLoginClick}
              data-test-id={testId('loginBtn')}>Sign In</button>
          </form>
        </div>
      </aside>
    );
  }
}

function mapStateToProps(state) {
  const {
    cookies: {
      ['x-main']: isRecognizedCustomer,
      [CLOSED_LA_COOKIE]: hideLADueToCustomerClosedIt
    },
    routing: { locationBeforeTransitions }
  } = state;

  return {
    isInLoginAssistantTest: isAssigned(HYDRA_LAS, 1, state),
    isRecognizedCustomer: !!isRecognizedCustomer,
    hideLADueToCustomerClosedIt: !!hideLADueToCustomerClosedIt,
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    locationBeforeTransitions
  };
}

LoginAssistant.contextTypes = {
  marketplace: PropTypes.object,
  testId: PropTypes.func
};

export default connect(mapStateToProps, {
  onCloseLoginAssistantClick,
  onLoginFromLoginAssistantClick,
  onShowLoginAssistant,
  triggerAssignment
})(LoginAssistant);

